import React from "react";
import { DevAuthProvider } from "./DevAuthProvider";
import useCheckEnvProtect from "./useCheckEnvProtect";
const LayoutProtect = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const showProtect = useCheckEnvProtect();
  return (
    <div>
      {showProtect ? (
        <DevAuthProvider>{children}</DevAuthProvider>
      ) : (
        <>{children}</>
      )}
    </div>
  );
};
export default LayoutProtect;
